 
import { NgIf } from '@angular/common';
import { Component, inject, OnDestroy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Amplify } from '@aws-amplify/core';
import { NbLayoutModule, NbSidebarModule, NbSidebarService } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { Subject, takeUntil } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { CONFIG, ENVIRONMENT } from '../environments/environment';
import { RouterState } from './features/auth/redux/router-state';
import { HeaderComponent } from './theme/components/header/header.component';
import { PagesComponent } from './theme/pages/pages.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [NbLayoutModule, NgIf, HeaderComponent, NbSidebarModule, PagesComponent, RouterOutlet]
})
export class AppComponent implements OnDestroy {
  public isLoggedIn$: Observable<boolean> = inject(Store).select(RouterState.isLogedIn);
  private unsubscribe = new Subject<void>();

  public isLoggedIn = false;
  public compacted = false;
  public environment = ENVIRONMENT;

  constructor(
    private router: Router,
    private sidebarService: NbSidebarService
  ) {
    Amplify.configure(CONFIG);
    this.sidebarService
      .onToggle()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(() => (this.compacted = !this.compacted));
    this.isLoggedIn$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.isLoggedIn = data));
    const url = new URL(window.location.href);
    if (url.pathname.includes('callback')) {
      const queryParams = Object.fromEntries(url.searchParams.entries());
      this.router.navigate(['/redirect'], { queryParams: { error: queryParams.error } });
    } else if (window.location.href.includes('signout')) {
      this.router.navigateByUrl('/signout');
    } else {
      this.router.navigateByUrl('/login');
    }
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
